import { Search, SpaRounded } from "@mui/icons-material";
import { Box, Card, IconButton, InputAdornment, TableContainer, TextField, Popover, Typography, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useState } from "react";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import { toast } from "react-toastify";
import { ROLES_CONTENT_PROPS } from "../../../shared/constants/constant-data";
import useRolePermissions from "../../../shared/hooks/useRolePermissions";
import white_globalCred from "../../../assets/global_cred.svg";
import globalCred from "../../../assets/white_global_cred.svg";

const CredentionalList = ({ onActiveCredentialChange, onCreateNewCredential, isDarkMode, credintialsData }: any) => {
    const theme = useTheme();
    const [isLoading, setIsLoading] = useState(false);
    const [activeCredential, setActiveCredential] = useState<any>(null); // State for active credential
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null); // State for popover
    const [searchQuery, setSearchQuery] = useState("");
    const { hasPermissions } = useRolePermissions();



    const handleCredentialClick = (credential: any) => {
        setActiveCredential(credential);
        onActiveCredentialChange(credential);
    };

    const handleAddClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget); // Open popover
    };

    const handlePopoverClose = () => {
        setAnchorEl(null); // Close popover
    };

    const handleCreateLocalCredential = () => {
        setActiveCredential(null);
        onCreateNewCredential("local"); // Notify parent about creating a local credential
        handlePopoverClose();
    };

    const handleCreateGlobalCredential = () => {
        setActiveCredential(null);
        onCreateNewCredential("global"); // Notify parent about creating a global credential
        handlePopoverClose();
    };

    //  useEffect(() => {
    //     if (credintialsData.length > 0) {
    //         setActiveCredential(credintialsData[0]); // Set the first credential as active by default
    //         onActiveCredentialChange(credintialsData[0]); // Notify parent about the active credential
    //     } else {
    //         setActiveCredential(null); // Clear active credential if no data
    //         onActiveCredentialChange(null); // Notify parent about no active credential
    //     }
    //  },[])


    useEffect(() => {
        if (filteredCredentials.length === 0) {
            setActiveCredential(null);
            onActiveCredentialChange(null);
        } else if (
            activeCredential &&
            !filteredCredentials.some((cred: any) => cred.id === activeCredential.id)
        ) {
            setActiveCredential(filteredCredentials[0]);
            onActiveCredentialChange(filteredCredentials[0]);
        }
        // If activeCredential is already in filteredCredentials, do nothing
        // If no activeCredential, set to first filtered
        else if (!activeCredential && filteredCredentials.length > 0) {
            setActiveCredential(filteredCredentials[0]);
            onActiveCredentialChange(filteredCredentials[0]);
        }
    }, [searchQuery, credintialsData]);


    const filteredCredentials = credintialsData.filter(
        (credential: any) =>
            credential?.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <Card className="white-box">
                <div
                    style={{
                        borderBottom: "1px solid #E2E2F2",
                    }}
                >
                    <form autoComplete="off">
                        <TextField
                            size="small"
                            variant="standard"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Search Credential"
                            fullWidth
                            autoComplete="off"
                            name="disable-autofill-search"
                            sx={{
                                m: 1,
                                width: 'calc(100% - 16px)',
                                color: theme.palette.text.primary,
                                borderRadius: "6px",
                                border: "1px solid",
                                borderColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)",
                                backgroundColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.02)",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    borderColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.24)" : "rgba(0, 0, 0, 0.24)",
                                },
                                "&:focus-within": {
                                    borderColor: isDarkMode ? theme.palette.primary.main : "",
                                    boxShadow: isDarkMode ? `0 0 0 2px ${theme.palette.primary.main}25` : "",
                                    backgroundColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
                                },
                                "& .MuiInputBase-root": {
                                    height: "32px !important",
                                    minHeight: "32px !important",
                                    alignItems: "center",
                                    paddingLeft: "8px",
                                    paddingRight: "8px",
                                },
                                "& .MuiInputBase-input": {
                                    color: theme.palette.text.primary,
                                    lineHeight: "32px",
                                    padding: "0px !important",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    color: theme.palette.text.secondary,
                                    opacity: 0.8,
                                },
                                "& fieldset": { border: "none" },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                                endAdornment: (

                                    <InputAdornment position="end">
                                        {searchQuery && (
                                            <IconButton size="small" onClick={() => setSearchQuery("")} sx={{ mr: 1 }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                        {(hasPermissions(ROLES_CONTENT_PROPS.CREATE_LOCAL_CREDENTIAL) || hasPermissions(ROLES_CONTENT_PROPS.CREATE_GLOBAL_CREDENTIAL)) &&
                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                <IconButton size="small" onClick={handleCreateGlobalCredential}>
                                                    <AddIcon sx={{ fill: "#3a2ada" }} />
                                                </IconButton>
                                            </Box>
                                        }
                                    </InputAdornment>
                                ),
                                disableUnderline: true,
                            }}
                        />
                    </form>
                    {/* <Popover
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                    >
                        <Box sx={{ p: 1, border: "1px solid #E2E2F2", boxShadow: '0px 4px 20px #E2E2F2', }}>

                            {hasPermissions(ROLES_CONTENT_PROPS.CREATE_GLOBAL_CREDENTIAL) &&

                                <Typography
                                    sx={{ cursor: "pointer", p: 1 }}
                                    onClick={handleCreateGlobalCredential}
                                >
                                    Create Global Credential
                                </Typography>
                            }
                        </Box>
                    </Popover> */}
                    <TableContainer
                        style={{
                            height: "calc(100vh - 160px)",
                            width: "100%",
                            overflow: "auto",
                            position: "relative",
                            // display: "flex",
                            // alignItems: "center",
                            // justifyContent: "center",

                        }}
                        className="scroll"
                    >
                        {!isLoading && filteredCredentials.length > 0 ? (
                            <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                                {filteredCredentials.map((credential: any, index: number) => (
                                    <li
                                        key={credential.id}
                                        onClick={() => handleCredentialClick(credential)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "10px",
                                            backgroundColor: activeCredential?.id === credential.id
                                                ? "blue"
                                                : index % 2 === 0
                                                    ? isDarkMode
                                                        ? "#333333"
                                                        : "#F8F8FF"
                                                    : isDarkMode
                                                        ? "#000000"
                                                        : "transparent",
                                            color: activeCredential?.id === credential.id
                                                ? "white"
                                                : isDarkMode
                                                    ? "#ffffff"
                                                    : "#000000",
                                        }}
                                        title={credential.name}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            {credential.name}
                                            {credential.global_cred && <span><img src={isDarkMode || activeCredential?.id === credential.id ? white_globalCred : globalCred} alt="exclamation" /></span>}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 190px)' }}>
                                <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}>{isLoading ? "Loading..." : "No data available to show"}</p>
                            </div>
                        )}
                    </TableContainer>
                </div>
            </Card>
        </>
    );
};

export default CredentionalList;